import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import ReactGA from "react-ga4";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { io } from "socket.io-client";
import Testing from "./Testing";
import { clearCacheData } from "./components/Hooks/clearCacheData";
import Page404 from "./components/Page404";
import axios from "./components/Hooks/axios";
import ViewPost from "./components/PostView/ViewPost";
import SharePopup from "./components/SharePopup/SharePopup";
import ViewStory from "./components/StoryView/ViewStory";
import Ads from "./pages/ADS/Dashboard/Ads";
import UsersReviews from "./pages/ADS/UsersReviews/UsersReviews";
import YourAds from "./pages/ADS/YourAds/YourAds";
import { Chat } from "./pages/Chat/Chat";
import ChoseTemplate from "./pages/ChoseTemplate/ChoseTemplate";
import PersonaRedirect from "./pages/ChoseTemplate/PersonaRedirect";
import Explore from "./pages/Explore/Explore";
import Congratulations from "./pages/Get Started/Common Screen/Congratulations/Congratulations";
import GetStarted1 from "./pages/Get Started/Common Screen/Get Started/GetStarted1";
import Interest from "./pages/Get Started/Common Screen/Interest/Interest";
import Persona from "./pages/Get Started/Personal/Persona";
import ProfessionalPersona from "./pages/Get Started/Professional/ProfessionalPersona";
import Home from "./pages/Home/Home";
import UploadPost from "./pages/Home/UploadPost";
import AudienceInsights from "./pages/Insights/AudienceInsights";
import BusinessInsights from "./pages/Insights/BusinessInsights";
import PersonalInsights from "./pages/Insights/PersonalInsights";
import ChangePassword from "./pages/Loading/Change Password/ChangePassword";
import ForgetPassword from "./pages/Loading/Forget Password/ForgetPassword";
import LoadingScreen from "./pages/Loading/Loading Screen/LoadingScreen";
import SignIn from "./pages/Loading/Sign In/SignIn";
import SignUp from "./pages/Loading/Sign Up/SignUp";
import Verification from "./pages/Loading/Verification/Verification";
import EditPost from "./pages/Post/EditPost";
import PostIndex from "./pages/Post/PostIndex";
import Security from "./pages/Security/Security";
import BlockedUser from "./pages/Setting/BlockedUser";
import FollowList from "./pages/Setting/FollowList";
import Privacy from "./pages/Setting/Privacy";
import Setting from "./pages/Setting/Setting";
// import PrivacyPolicy from "./pages/Static/PrivacyPolicy";
import Terms from "./pages/Static/Terms";
import Support from "./pages/Support/Support";
import DataDeletion from "./pages/Static/DataDeletion";
import { fetchUserAccount } from "./redux/slices/accountSlice";
import { fetchDataFromLocalStorage, setUserObject, logOut } from "./redux/slices/authSlice";
import { fetchNotificationHistory, fetchNotifications } from "./redux/slices/notificationSlice";
import notificationSound from "./assets/sound/mixkit-clear-announce-tones-2861.wav";
import MobileSignUp from "./pages/Loading/Sign Up/MobileSignUp";
import MobileSignIn from "./pages/Loading/Sign In/MobileSignIn";
import MobileForgetPassword from "./pages/Loading/Forget Password/MobileForgetPassword";
import MobileVerification from "./pages/Loading/Verification/MobileVerification.jsx";
import MobileChangePassword from "./pages/Loading/Change Password/MobileChangePassword.jsx";
import UploadPost2 from "./pages/UploadPost2/UploadPost2.jsx";
import StoryWrapper from "./pages/Stories/StoryWrapper.jsx";
import UploadStories from "./pages/UploadStories/UploadStories.jsx";
import Stream from "./pages/Stream/Stream.jsx";
import SettingPage from "./pages/Setting/SettingPage.jsx";
import SocialLinks from "./pages/Setting/SocialLinks/SocialLinks.jsx";
import TermsAndCondition from "./pages/Security/Security modal/Terms and condition/Terms&Condition.jsx";
import PrivacyPolicy from "./pages/Security/Security modal/Privacy/SecurityPrivacy.jsx";
import SecurityPrivacy from "./pages/Security/Security modal/Privacy/SecurityPrivacy.jsx";
import PostVisit from "./pages/Insights/PostVisit.jsx";
import PostWrapper from "./pages/UploadPost2/PostWrapper.jsx"
import CustomPoll from "./pages/Home/CustomPoll.jsx";
import Poll from "./pages/Home/Poll.jsx";
import AskFameo from "./pages/AskFameo/AskFameo.jsx";
import AskFameoAI from "./pages/AskFameoAI/AskFameoAI.jsx";
import OrientationGuard from "./components/OrientationGuard/OrientationGuard";

const baseURL = process.env.REACT_APP_BASE_API_URL || "";
const socketURL = baseURL.endsWith("/api") ? baseURL.slice(0, -4) : baseURL;

export const socket = io(`${socketURL}/socket_connection`, {
	transports: ["websocket"],
	withCredentials: true
});
// export const socket = io(`http://localhost:5005/socket_connection`);

function App() {
	const dispatch = useDispatch();
	const { reload } = useSelector((state) => state.notification);
	const { userId, user } = useSelector((state) => state.auth);
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const toastId = useRef(null);
	const {
		share: { show },
	} = useSelector((state) => state.temp);

	useEffect(() => {
		const handleStatusChange = () => setIsOnline(navigator.onLine);

		window.addEventListener("online", handleStatusChange);
		window.addEventListener("offline", handleStatusChange);

		if (!isOnline)
			toastId.current = toast.error("You are Offline !!", {
				position: "top-center",
				autoClose: false,
				closeOnClick: true,
			});
		else toast.dismiss(toastId.current);

		return () => {
			window.removeEventListener("online", handleStatusChange);
			window.removeEventListener("offline", handleStatusChange);
		};
	}, [isOnline]);

	useEffect(() => {
		dispatch(fetchUserAccount());
		dispatch(fetchDataFromLocalStorage());
	}, []);

	useEffect(() => {
		if (userId === "") return;
		if (user?.is_active === true) socket.emit("joinLoginRoom", { userId });
		else socket.emit("joinLoginRoom", { userId, activeStatus: false });

		// Fetch user details if missing to ensure onboarding guard works
		if (!user) {
			axios
				.get(`/auth/get-user-details/${userId}`)
				.then(({ data }) => {
					if (data && data.isVerified === false) {
						dispatch(logOut());
						window.location.href = "/signup";
						return;
					}
					dispatch(setUserObject(data));
				})
				.catch((e) => {
					console.log(e);
					if (e.response?.status === 401 || e.response?.status === 403) {
						dispatch(logOut());
					}
				});
		}
	}, [socket, userId, user?.is_active]);

	useEffect(() => {
		if (!userId) return;

		socket.emit("notificationHistory", userId);

		const handler = (payload) => {
			dispatch(fetchNotificationHistory(payload));
		};

		socket.on(`notificationHistory_${userId}`, handler);

		return () => {
			socket.off(`notificationHistory_${userId}`, handler);
		};

	}, [userId, reload]);

	useEffect(() => {
		if (!userId) return;

		const handler = (payload) => {
			dispatch(fetchNotifications(payload));

			// 1. Play sound if notification sound is enabled
			if (user?.notification_sound) {
				try {
					const soundAudio = new Audio(notificationSound);
					soundAudio.play().catch((err) => console.log("Audio notification play error:", err));
				} catch (e) {
					console.log("Audio creation error:", e);
				}
			}

			const senderName = payload?.notification_from?.displayName || payload?.notification_from?.username || "Fameo Notification";
			const senderPic = payload?.notification_from?.ProfilePic || "/favicon.ico";
			const notifMsg = payload?.message || payload?.title || "You have received a new notification";

			// 2. In-screen popup notification banner
			toast.info(
				<div
					style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}
					onClick={() => {
						if (payload?.notification?.link) {
							window.location.href = payload.notification.link;
						}
					}}
				>
					<img
						src={senderPic}
						alt=""
						style={{ width: "38px", height: "38px", borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
						onError={(e) => { e.target.src = "/favicon.ico"; }}
					/>
					<div>
						<div style={{ fontWeight: 600, fontSize: "14px" }}>{senderName}</div>
						<div style={{ fontSize: "12px", opacity: 0.9, marginTop: "2px" }}>{notifMsg}</div>
					</div>
				</div>,
				{
					position: "top-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
				}
			);

			// 3. Native desktop notification if enabled
			if (user?.desktop_notification && typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted") {
				try {
					const notif = new Notification(`${senderName} on Fameo`, {
						body: notifMsg,
						icon: senderPic,
					});
					notif.onclick = () => {
						window.focus();
						if (payload?.notification?.link) {
							window.location.href = payload.notification.link;
						}
						notif.close();
					};
				} catch (err) {
					console.log("Desktop notification error:", err);
				}
			}
		};

		socket.on(`notifications_${userId}`, handler);

		return () => {
			socket.off(`notifications_${userId}`, handler);
		};
	}, [userId, user?.desktop_notification, user?.notification_sound]);

	clearCacheData();

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);


	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={3000}
				limit={4}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss={false}
				draggable
				pauseOnHover={false}
				theme="colored"
			/>

			{/* NOTE: Share Popup 👇 */}
			{show && <SharePopup />}

			<BrowserRouter>
				<OrientationGuard />
				<Routes>
					<Route element={<AnalyticWrapper />}>
						<Route path="*" element={<Page404 />} />
						<Route path="/" element={isMobile ? <MobileSignIn /> : <LoadingScreen />} />
						<Route path="/signup" element={isMobile ? <MobileSignUp /> : <SignUp />} />
						<Route path="/signin" element={isMobile ? <MobileSignIn /> : <SignIn />} />
						<Route path="/forget-password" element={isMobile ? <MobileForgetPassword /> : <ForgetPassword />} />
						<Route path="/verification-code" element={isMobile ? <MobileVerification /> : <Verification />} />
						<Route path="/change-password" element={isMobile ? <MobileChangePassword /> : <ChangePassword />} />
						<Route path="/interest" element={<Interest />} />
						<Route path="/get-started" element={<GetStarted1 />} />
						<Route path="/get-started/personal" element={<Persona />} />
						<Route path="/get-started/professional" element={<ProfessionalPersona />} />
						<Route path="/get-started/congratulation" element={<Congratulations />} />

						<Route element={<LoginWrapper />}>
							<Route path="/ChoseTemplate" element={<ChoseTemplate />} />
							<Route path="/PersonaRedirect" element={<PersonaRedirect />} />
							<Route path="/Home" element={<Home />} />
							<Route path="/Explore" element={<Explore />} />
							<Route path="/Post" element={<PostIndex />} />
							<Route path="/UploadPost" element={<UploadPost />} />
							{/* <Route path="/UploadPost2" element={<UploadPost2 />} /> */}
							<Route path="/UploadPost2" element={<PostWrapper />} />

							<Route path="/AskFameo" element={<AskFameo />} />
							<Route path="/AskFameoAI" element={<AskFameoAI />} />

							{/* customPoll */}
							<Route path="/customPoll" element={<CustomPoll />} />
							<Route path="/Poll" element={<Poll />} />

							<Route path="/UploadStories" element={<UploadStories />} />
							<Route path="/LiveStream" element={<Stream />} />
							<Route path="/EditPost/:id" element={<UploadPost />} />
							<Route path="/PersonalInsights" element={<PersonalInsights />} />
							<Route path="/BusinessInsights" element={<BusinessInsights />} />
							<Route path="/AudienceInsights" element={<AudienceInsights />} />
							<Route path="/PostVisit" element={<PostVisit />} />
							<Route path="/Setting" element={<SettingPage />} />
							<Route path="/SocialLinks" element={<SocialLinks />} />
							<Route path="/Security" element={<Security />} />
							<Route path="/Privacy" element={<Privacy />} />
							<Route path="/BlockedUser" element={<BlockedUser />} />
							<Route path="/FollowList" element={<FollowList />} />
							<Route path="/Chat" element={<Chat />} />
							<Route path="/Chat/:id" element={<Chat />} />
							<Route path="/Support" element={<Support />} />
							<Route path="/YourAds" element={<YourAds />} />
						</Route>

						{/* Publicly accessible view routes for sharing and legal pages */}
						<Route path="/Post/:id" element={<ViewPost />} />
						<Route path="/Story/:id" element={<ViewStory />} />
						<Route path="/data-deletion" element={<DataDeletion />} />
						<Route path="/TermsAndCondition" element={<TermsAndCondition />} />
						<Route path="/terms" element={<TermsAndCondition />} />
						<Route path="/terms-and-conditions" element={<TermsAndCondition />} />
						<Route path="/terms-of-service" element={<TermsAndCondition />} />
						<Route path="/PrivacyPolicy" element={<SecurityPrivacy />} />
						<Route path="/privacy-policy" element={<SecurityPrivacy />} />
					</Route>
					<Route path="/Testing" element={<Testing />} />
				</Routes>
			</BrowserRouter>
		</>
	);
}

export default App;

const LoginWrapper = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const userCookies = Cookies.get("E_current_userId");
	const tokenCookie = Cookies.get("E_token");

	useEffect(() => {
		if (
			!userCookies ||
			userCookies === "undefined" ||
			userCookies === "null" ||
			!tokenCookie ||
			tokenCookie === "undefined" ||
			tokenCookie === "null"
		) {
			dispatch(logOut());
			return navigate("/");
		}

		if (user && user.isVerified === false) {
			dispatch(logOut());
			return navigate("/signup", { replace: true });
		}

		// Guard: If user is logged in but hasn't completed interest selection, redirect to interest page
		if (user && (!user.interestName || user.interestName.length === 0)) {
			navigate("/interest", { replace: true });
		}
	}, [userCookies, tokenCookie, user, navigate, dispatch]);

	return <Outlet />;
};

const AnalyticWrapper = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		ReactGA.send({ hitType: "pageview", page: pathname, title: pathname });
	}, [pathname]);

	return <Outlet />;
};

